<template>
  <div class="DeepCompDetail">
    <!-- 头部 -->
    <top-header ref="myHeader">
      <template v-slot:bookTitle>
        <span
          style="width: calc(100% - 2.5rem);overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #333333;font-size: .28rem;"
          >{{ "/ " + BookTitle }}</span
        >
      </template>
    </top-header>
    <!-- banner -->
    <Banner />
    <!-- 面包屑 -->
    <div class="breadcrumbWrap">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ BookTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
      <a
        href="https://www.tunnelling.cn/PMember/mybooklist.aspx"
        target="_blank"
        >我的知识平台</a
      >
    </div>
    <!-- 详情 -->
    <div class="BookContWrap">
      <!-- 左部分 -->
      <div class="leftContWrap">
        <!--        合集信息-->
        <div class="bookInfo">
          <div class="left">
            <img :src="bookCollection.imagePath" :onerror="defaultImg" />
          </div>
          <div class="right">
            <p class="title">{{ bookCollection.name }}</p>
            <span>{{ bookCollection.introduction }}</span>
            <div>
              <p
                :class="isgoods ? 'nodisabledBook' : 'disabledBook'"
                @click="AllBookDownload"
              >
                <span></span>购买电子书
              </p>
            </div>
          </div>
        </div>
        <!--        图书列表-->
        <ItemTitle title="图书列表" />
        <div class="bookList">
          <ul>
            <li
              class="bookItem"
              v-for="(item, index) in subCategoryList"
              :key="index"
            >
              <div class="left">
                <img :src="item.information.imagePath" :onerror="defaultImg" />
              </div>
              <div class="right">
                <router-link
                  :to="{
                    path: '/bookDetail',
                    query: { InformationId: item.information.id }
                  }"
                  target="_blank"
                  ><p :title="item.information.title">
                    {{ item.information.title }}/
                  </p></router-link
                >
                <span>{{ item.information.abstract }}</span>
              </div>
            </li>
          </ul>
          <!--          <div class="newest-look-more"><a href="#">查看更多</a></div>-->
        </div>
        <!-- 版本说明 -->
        <div class="statement">
          <p>免责声明</p>
          <p>
            本网“知识服务平台”栏目全部内容均由隧道网编译整理，文中出现的数据、参数等内容，仅供工程技术人员学习，并不作为施工技术指导，如因参考上述内容出现任何问题，均有个人负责，隧道网不承担责任；如文中翻译内容有误，敬请批评指正！上述内容，未经隧道网授权，不得转载、摘编或以其它方式使用上述作品。违反上述声明者，本网将保留追究其相关法律责任的权利，如有其他问题请与本网联系。
          </p>
        </div>
      </div>
      <!-- 右部分 -->
      <div class="rightContWrap">
        <DetailOther />
      </div>
    </div>
    <!-- 加入购物车成功提示 -->
    <div v-if="showAddCartTip">
      <addCartSuccess :show-book="false" :show-content="showContent" />
    </div>
    <!-- 页脚 -->
    <BottomFooter />
    <!-- 在线客服 -->
    <online-service />
  </div>
</template>

<script>
import TopHeader from "../../components/TopHeader.vue";
import Banner from "../../components/Banner.vue";
import DetailOther from "../../components/DetailOther.vue";
import ItemTitle from "../../components/ItemTitle.vue";
import BottomFooter from "../../components/BottomFooter.vue";
import OnlineService from "../../components/OnlineService.vue";
import addCartSuccess from "../../components/addCartSuccess.vue";
import common from "../../assets/js/common.js";
export default {
  name: "DeepCompDetail",
  components: {
    addCartSuccess,
    OnlineService,
    BottomFooter,
    ItemTitle,
    DetailOther,
    TopHeader,
    Banner
  },
  data() {
    return {
      BookTitle: "", // 书名
      informationCategoryId: 0, // 合集id
      isFromNews: false, // 是否从最新更新跳转过来
      isgoods: true, // 是否是商品
      bookCollection: {}, // 书集合集
      subCategoryList: [], // 二级分类
      defaultImg: 'this.src="' + require("../../assets/img/default_pic.png") + '"', //默认封面
      showAddCartTip: false, // 加入购物车成功提示
      showContent: true // 加入购物车弹框显示文字
    };
  },
  mounted() {
    // 获取合集id
    this.informationCategoryId = +this.$route.query.informationCategoryId;
    // 获取合集数据
    this.getBookCollecton(this.informationCategoryId);
    // 关闭加入购物车成功的提示
    common.$on("closeTip", () => {
      this.showAddCartTip = false;
    });
  },
  methods: {
    //   获取查询合集
    getBookCollecton(id) {
      this.$fetch(
        `/api/informationCategories/${id}/informationSubCategories/informationCategoryId`
      ).then(res => {
        if (res.status === 200) {
          res.data.forEach(item => {
            this.subCategoryList = item.information_InformationSubCategory;
            this.bookCollection = item;
            this.BookTitle = item.name;
          });
        }
      });
    },
    // 判断是否登录
    LoginTip(param) {
      this.$confirm("此操作需登录后进行，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let nowHref = location.href;
          let href =
            "https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=" +
            encodeURIComponent(nowHref);
          location.href = href;
        })
        .catch(() => {});
    },
    //   集合加入购物车
    AllBookDownload() {
      this.$fetch("/Login").then(res => {
        // 判断登陆状态
        if (res.data.accessAllowed === false) {
          this.LoginTip();
          return;
        }
        this.showAddCartTip = true;
        this.getAddCarts(this.informationCategoryId);
      });
    },
    // 集合id加入购物车
    getAddCarts(id) {
      this.$post(
        `/api/ShoppingCarts/CollectionIdCreate?informationCategoryId=${id}`
      ).then(res => {
        if (res.data && res.data.existID.length !== 0) {
          this.showContent = false;
        } else {
          this.showContent = true;
        }
      });
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
  .rightContWrap,
  .breadcrumbWrap {
    display: none;
  }

  .BookDetailWap .Banner {
    display: none;
  }

  .BookContWrap {
    width: 100%;
    margin: 0.2rem auto 0;
    padding: 0 0.25rem;
  }

  .BookContWrap .leftContWrap .bookInfo {
    display: flex;
    justify-content: start;
  }

  .BookContWrap .leftContWrap .bookInfo .left img {
    margin-right: 0.2rem /* 20/100 */;
    width: 2rem /* 100/100 */;
  }

  .BookContWrap .leftContWrap .bookInfo .right .title {
    font-size: 0.18rem /* 18/100 */;
    font-weight: 600;
    color: #333333;
    line-height: 0.2rem /* 20/100 */;
    margin-bottom: 0.1rem /* 10/100 */;
  }

  .BookContWrap .leftContWrap .bookInfo .right span:nth-child(2) {
    font-size: 0.14rem /* 14/100 */;
    color: #666666;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }

  .leftContWrap .bookInfo .right p:last-child {
    color: #ffffff;
    cursor: pointer;
    background: #2468f2;
    font-size: 0.14rem /* 14/100 */;
    letter-spacing: 0.69px;
    line-height: 0.14rem /* 14/100 */;
    padding: 0.1rem 0.2rem;
  }

  .leftContWrap .bookInfo .right p span {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 6px;
    background: url(../../assets/img/detailsAllBook_icon.svg) no-repeat;
  }

  .leftContWrap .bookInfo .right div {
    display: flex;
    justify-content: end;
    margin-top: 0.25rem;
  }

  .leftContWrap .bookTab {
    margin-top: 0.3rem;
    font-size: 0.32rem;
    color: #424242;
  }

  .leftContWrap .bookList .bookItem {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-top: 0.2rem;
  }

  .leftContWrap .bookList .bookItem .left img {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.2rem;
  }

  .leftContWrap .bookList .bookItem .right p {
    font-size: 0.18rem /* 18/100 */;
    font-weight: 600;
    color: #333333;
    line-height: 0.2rem /* 20/100 */;
    margin-bottom: 0.1rem /* 10/100 */;
  }

  .leftContWrap .bookList .bookItem .right span {
    font-size: 0.14rem /* 14/100 */;
    color: #666666;
    font-weight: 400;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  /* 查看更多 */
  /*.newest-look-more {*/
  /*  background: #FBFBFB;*/
  /*  text-align: center;*/
  /*  color: #424242;*/
  /*  margin: 0.25rem 0 0.3rem;*/
  /*  cursor: pointer;*/
  /*  line-height: .6rem;*/
  /*  font-size: .28rem;*/
  /*}*/

  /* 版本声明 */
  .statement {
    width: 100%;
    background: #fafafa;
    color: #666666;
    padding: 0.2rem 0.2rem 1.2rem;
    margin: 0.3rem 0 0;
  }

  .statement p:first-child {
    font-size: 15px;
    text-align: center;
  }

  .statement p:last-child {
    text-indent: 30px;
    font-size: 12px;
    letter-spacing: 0.5px;
    line-height: 24px;
  }
}
@media screen and (min-width: 1029px) {
  /* 面包屑 */
  .breadcrumbWrap {
    width: 1200px;
    margin: 20px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .breadcrumbWrap > a {
    font-size: 14px;
    background: #2468f2;
    padding: 5px 15px;
    border-radius: 4px;
    color: #ffffff;
  }

  .BookContWrap {
    width: 1200px;
    margin: 50px auto 0;
    display: flex;
  }

  /* 左部分 */
  .leftContWrap {
    width: 820px;
    margin-right: 60px;
  }

  .leftContWrap .bookInfo {
    padding: 10px 0 26px 0;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }

  .leftContWrap .bookInfo .left img {
    height: 218px;
    width: 244px;
  }

  .leftContWrap .bookInfo .right {
    width: 543px;
  }

  .leftContWrap .bookInfo .right .title {
    margin-bottom: 20px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #424242;
    line-height: 30px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
  }

  .leftContWrap .bookInfo .right span:nth-child(2) {
    margin-bottom: 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 24px;
    height: 144px;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }

  .leftContWrap .bookInfo .right p:last-child {
    color: #ffffff;
    cursor: pointer;
    background: #2468f2;
    font-size: 16px;
    letter-spacing: 0.69px;
    line-height: 16px;
    padding: 10px 20px;
    display: inline-block;
  }

  .leftContWrap .bookInfo .right p span {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 6px;
    background: url(../../assets/img/detailsAllBook_icon.svg) no-repeat;
  }

  .leftContWrap .bookInfo .right div {
    display: flex;
    justify-content: end;
  }

  .leftContWrap .bookList .bookItem {
    margin-top: 20px;
    padding: 20px;
    width: 100%;
    height: 200px;
    background: #fafafa;
    display: flex;
    justify-content: start;
  }

  .leftContWrap .bookList .bookItem .right {
    margin-left: 20px;
    width: 590px;
  }

  .leftContWrap .bookList .bookItem .right p {
    margin: 10px 0;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
  }

  .leftContWrap .bookList ul {
    margin-bottom: 20px;
  }

  .leftContWrap .bookList .bookItem .left img {
    width: 124px;
    height: 160px;
  }

  .leftContWrap .bookList .bookItem .right span {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }

  /*查询更多*/
  /*.leftContWrap .bookList .newest-look-more {*/
  /*  display: block;*/
  /*  line-height: 48px;*/
  /*  font-size: 18px;*/
  /*  background: #FBFBFB;*/
  /*  text-align: center;*/
  /*  color: #424242;*/
  /*  margin: 20px 0 40px;*/
  /*  cursor: pointer;*/
  /*}*/

  /* 禁用 */
  .nodisabledBook {
    background: #2468f2 !important;
  }

  .disabledBook {
    background: gray !important;
    cursor: default !important;
  }

  /* 版本声明 */
  .statement {
    width: 100%;
    background: #fafafa;
    color: #666666;
    padding: 30px 119px;
    margin: 30px 0 120px 0;
  }

  .statement p:first-child {
    font-size: 16px;
    margin-bottom: 19px;
    text-align: center;
  }

  .statement p:last-child {
    text-indent: 30px;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/DeepCompilations/DeepCompDetail.vue